import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class TaxTxnQueryCriteriaClass extends BaseCriteriaModel {
  //bl_fi_tax_txn table
  comp_guid?: Optional<string> = Optional.empty();
  branch_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  entity_hdr_guid?: Optional<string> = Optional.empty();
  doc_hdr_guid?: Optional<string> = Optional.empty();
  tax_filing_date?: Optional<string> = Optional.empty();
}

export class TaxTxnCriteriaModelQuery {
  query = '';

  constructor(TaxTxnCriteriaModel: TaxTxnQueryCriteriaClass) {

    if (!TaxTxnCriteriaModel) {
      return;
    }

    this.query += TaxTxnCriteriaModel.comp_guid.filter(x => x !== '').map(x => '&comp_guid=' + x).orElse('');
    this.query += TaxTxnCriteriaModel.branch_guid.filter(x => x !== '').map(x => '&branch_guid=' + x).orElse('');
    this.query += TaxTxnCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += TaxTxnCriteriaModel.entity_hdr_guid.filter(x => x !== '').map(x => '&entity_hdr_guid=' + x).orElse('');
    this.query += TaxTxnCriteriaModel.doc_hdr_guid.filter(x => x !== '').map(x => '&doc_hdr_guid=' + x).orElse('');
    this.query += TaxTxnCriteriaModel.tax_filing_date.filter(x => x !== '').map(x => '&tax_filing_date=' + x).orElse('');

    this.query += '&status=' + TaxTxnCriteriaModel.status;
    this.query += '&orderBy=' + TaxTxnCriteriaModel.orderBy;
    this.query += '&order=' + TaxTxnCriteriaModel.order;
    this.query += '&offset=' + TaxTxnCriteriaModel.offset + '&limit=' + TaxTxnCriteriaModel.limit;
  }
}
